import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/login')
    },
    {
        path: '/forget',
        name: 'Forget',
        component: () => import('@/views/login/forget')
    },
    {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/index/index'),
        children: [
            {
                path: '/index',
                redirect: '/home/home',
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/home/home',
                name: 'home',
                component: () => import('@/views/home/home'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/account/account',
                name: '账号列表',
                component: () => import('@/views/account/account'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/city/city',
                name: 'city',
                component: () => import('@/views/city/city'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/city/add',
                name: 'city',
                component: () => import('@/views/city/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/agency/agency',
                name: '代理商管理',
                component: () => import('@/views/agency/agency'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/alliance/alliance',
                name: 'alliance',
                component: () => import('@/views/alliance/alliance'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/alliance/add',
                name: '添加加盟商',
                component: () => import('@/views/alliance/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/alliance/add',
                name: '添加类型代理',
                component: () => import('@/views/alliance/subAll'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/site',
                name: 'site',
                component: () => import('@/views/site/site'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/add-site',
                name: '新增场地',
                component: () => import('@/views/site/add-site'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/type',
                name: '类型管理',
                component: () => import('@/views/site/type'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/service/service',
                name: 'service',
                component: () => import('@/views/service/service'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/service/add',
                name: '新增服务商',
                component: () => import('@/views/service/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/service/type',
                name: '新增服务商类型',
                component: () => import('@/views/service/type'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/user/user',
                name: 'user',
                component: () => import('@/views/user/user'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/wechat/wechat',
                name: 'wechat',
                component: () => import('@/views/wechat/wechat'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/setting/setting',
                name: 'setting',
                component: () => import('@/views/setting/setting'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/authority/authority',
                name: 'authority',
                component: () => import('@/views/authority/authority'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/authority/add',
                name: '添加权限',
                component: () => import('@/views/authority/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/order/order',
                name: '订单管理',
                component: () => import('@/views/order/order'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/withdraw/withdraw',
                name: '提现管理',
                component: () => import('@/views/withdraw/withdraw'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/setting/edit',
                name: '信息修改',
                component: () => import('@/views/setting/edit'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/withdraw/count',
                name: '提现账号',
                component: () => import('@/views/withdraw/count'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/withdraw/apply',
                name: '提现申请',
                component: () => import('@/views/withdraw/apply'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/withdraw/setting',
                name: '比例设置',
                component: () => import('@/views/withdraw/setting'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/demand/demand',
                name: '需求管理',
                component: () => import('@/views/demand/demand'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/withdraw/setdk',
                name: '总台财务设置',
                component: () => import('@/views/withdraw/setdk'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/uploadFile/index',
                name: '案例列表',
                component: () => import('@/views/uploadFile/index'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/uploadFile/add',
                name: '案例上传',
                component: () => import('@/views/uploadFile/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/service/add-case',
                name: '服务商案例上传',
                component: () => import('@/views/service/add-case'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/service/case',
                name: '服务商案例',
                component: () => import('@/views/service/case'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/account/add',
                name: '添加账号',
                component: () => import('@/views/account/add'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/list',
                name: '类型列表',
                component: () => import('@/views/site/type-list'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/manage',
                name: '新增场地管理员列表',
                component: () => import('@/views/site/manage'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/site/mlist',
                name: '场地管理员列表',
                component: () => import('@/views/site/m-list'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/log/log',
                name: '安全日志',
                component: () => import('@/views/log/log'),
                meta: {
                    requireAuth: true
                }
            },
        ]
    },

]

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router


